import React, { Component } from "react";
import {
  Card,
  FlatButton,
  Dialog,
  TextField,
  IconButton,
  Snackbar,
  CircularProgress,
} from "material-ui";
import Loading from "../Loading";
import { FormsyText } from "formsy-material-ui/lib";
import Formsy from "formsy-react";
import Dropzone from "react-dropzone";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";

import deleteDefaultIcon from "../../images/delete_default.png";
import editDefaultIcon from "../../images/edit_default.png";
import backIcon from "../../images/back.png";
import addArrowIcon from "../../images/add_arrow.png";
import closeIcon from "../../images/close_icon.png";
import { Link } from "react-router";
import downloadIcon from "../../images/download.png";

export default class ShowCompanyDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      message:
        "You can also upload employee detail list from a csv. Drag & Drop employee detail list CSV here.",
      open: false,
      responseMsg: "",
      employee: {
        name: "",
        email: "",
        empId: "",
      },
      companyData: {
        company: "",
        companyId: "",
        _id: "",
        employees: [],
      },
      employeeList: [],
      showToast: false,
      toastMsg: "",
      styles: {
        centerStyle: {
          marginBottom: "1em",
          marginLeft: "auto",
          marginRight: "auto",
          width: "75%",
        },
        zone: {
          width: "100%",
          height: "300px",
          border: "3px dashed #ebeff2",
        },
        activeZone: {
          width: "100%",
          height: "300px",
          border: "3px dashed green",
          backgroundColor: "Aquamarine",
        },
        zoneText: {
          textAlign: "center",
          fontSize: "2em",
        },
      },
      openDeleteConfirmPopup: false,
      currentSelectedRow: {},
      file: "",
      companyOpen: false,
      company: {},
      searchTextValue: "",
      searchText: "",
      isEmployeeEdit: false,
    };
    this.onDrop = this.onDrop.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.deleteButtonFormatter = this.deleteButtonFormatter.bind(this);
    this.editButtonFormatter = this.editButtonFormatter.bind(this);
    this.submitSearchForm = this.submitSearchForm.bind(this);
  }

  onDrop(e) {
    if (e[0].name.toLowerCase().split(".")[1] === "csv") {
      this.setState({ file: e[0] });
    } else if (e[0].name) {
      this.setState({
        file: "",
        message: `Incorrect File Type, expecting CSV`,
      });
    } else {
      this.setState({
        file: "",
        message:
          "You can also upload employee detail list from a csv. Drag & Drop employee detail list CSV here.",
      });
    }
  }

  submitForm(data) {
    let me = this;
    if (this.state.file) {
      this.setState({ isLoading: true });
      let formData = new FormData();
      let url =
        "/api/payroll/uploadEmployee?companyId=" +
        this.state.companyData.companyId;
      let options = {
        method: "POST",
        headers: {
          token: this.props.token.jwt,
        },
        body: formData,
      };
      formData.append("file", this.state.file);
      fetch(url, options)
        .then((response) => response.json())
        .then((json) => {
          let { companyData } = me.state;
          companyData.employees = json;
          me.setState({
            companyData: companyData,
            isLoading: false,
            file: "",
            message:
              "You can also upload employee detail list from a csv. Drag & Drop employee detail list CSV here.",
          });
        });
    } else {
      alert("File error");
      this.setState({ isLoading: false });
    }
  }

  componentDidMount() {
    //this.getEmployeeList()
  }

  componentWillReceiveProps(props) {
    let { companyData, employee } = this.state;
    companyData._id = props.companyData._id;
    companyData.companyId = props.companyData.companyId;
    companyData.company = props.companyData.company;
    companyData.employees = props.companyData.employees;
    employee = { name: "", empId: "", email: "" };
    this.setState({ companyData: companyData, employee: employee });
  }

  addEmployee = () => {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    let { employee, companyData } = this.state;
    var me = this;
    if (employee.name == "" && employee.email == "" && employee.empId) {
      alert("Employee Id, Name and Email should not be blank.");
    } else if (employee.empId == "") {
      alert("Employee Id should not be blank.");
    } else if (employee.name == "") {
      alert("Name should not be blank.");
    } else if (employee.email == "") {
      alert("Email should not be blank.");
    } else if (!re.test(String(employee.email).toLowerCase())) {
      alert("Please enter valid email.");
    } else {
      let url =
        "/api/payroll/addEmployee?companyId=" +
        this.state.companyData.companyId;
      let options = {
        method: "POST",
        headers: {
          token: this.props.token.jwt,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(employee),
      };
      fetch(url, options)
        .then((res) => {
          if (res.status >= 200 && res.status < 300) {
            return res.json();
          } else {
            this.notifyFormError(res, "Internal server error.");
          }
        })
        .then((json) => {
          if (json.message == "employee already exist.") {
            this.notifyFormError(json, "Employee is already exist.");
          } else {
            employee.name = "";
            employee.email = "";
            employee.empId = "";
            companyData.employees = json.employees;
            me.setState({
              employee: employee,
              isEmployeeEdit: false,
              showToast: true,
              toastMsg: json.message,
            });
            //me.getEmployeeList();
          }
        });
    }
  };

  editEmployee = () => {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    let { employee, companyData } = this.state;
    var me = this;
    if (this.employeeValidation()) {
      return true;
    }
    let url =
      "/api/payroll/updateEmployee?companyId=" +
      this.state.companyData.companyId;
    let options = {
      method: "POST",
      headers: {
        token: this.props.token.jwt,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(employee),
    };
    fetch(url, options)
      .then((res) => {
        if (res.status >= 200 && res.status < 300) {
          return res.json();
        } else {
          this.notifyFormError(res, "Internal server error.");
        }
      })
      .then((json) => {
        if (json.message == "employee already exist.") {
          this.notifyFormError(json, "Employee is already exist.");
        } else {
          employee.name = "";
          employee.email = "";
          employee.empId = "";
          companyData.employees = json.employees;
          me.setState({
            employee: employee,
            showToast: true,
            toastMsg: json.message,
            isEmployeeEdit: false,
          });
          //me.getEmployeeList();
        }
      });
  };

  employeeValidation = () => {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    let { employee } = this.state;
    let flag = false;
    if (employee.name == "" && employee.email == "" && employee.empId != "") {
      alert("Employee Id, Name and Email should not be blank.");
      flag = true;
    } else if (employee.empId == "") {
      alert("Employee Id should not be blank.");
      flag = true;
    } else if (employee.name == "") {
      alert("Name should not be blank.");
      flag = true;
    } else if (employee.email == "") {
      alert("Email should not be blank.");
      flag = true;
    } else if (!re.test(String(employee.email).toLowerCase())) {
      alert("Please enter valid email.");
      flag = true;
    }
    return flag;
  };

  updateCompanyData = (companyData) => {
    this.setState({ companyData: companyData });
  };

  getEmployeeList() {
    let url = `/api/payroll/companyData?companyId=` + companyData.companyId;
    let body = companyData;
    let options = {
      method: "GET",
      headers: {
        token: this.props.token,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };
    fetch(url, options)
      .then((res) => {
        if (res.status >= 200 && res.status < 300) return res.json();
      })
      .then((json) => {
        companyData.company = json.companyData.company;
        companyData.companyData = json.companyData.companyId;
        companyData.employees = json.companyData.employees;
        me.setState({ companyData: companyData });
      });
  }

  onCompanyEmployeeValue = (key, value) => {
    let { employee } = this.state;
    if (key == "name") {
      employee.name = value;
    } else if (key == "empId") {
      employee.empId = value;
    } else {
      employee.email = value;
    }
    this.setState({ employee: employee });
  };

  onChangeValue = (value) => {
    let { companyData } = this.state;
    companyData.company = value;
    this.setState({ companyData: companyData });
  };

  notifyFormError(data, msg) {
    alert(msg);
  }

  deleteMailingTypeListUser = (row) => {
    this.setState({ currentSelectedRow: row, openDeleteConfirmPopup: true });
  };

  deleteConfirmPopupClick = () => {
    let { companyData, currentSelectedRow } = this.state;
    var me = this;
    let url = `/api/payroll/deleteEmployee?companyId=` + companyData.companyId;
    let body = currentSelectedRow;
    let options = {
      method: "POST",
      headers: {
        token: this.props.token.jwt,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    };
    fetch(url, options)
      .then((res) => {
        if (res.status >= 200 && res.status < 300) return res.json();
      })
      .then((json) => {
        this.setState({
          currentSelectedRow: {},
          openDeleteConfirmPopup: false,
        });
        companyData.employees = json.employees;
        me.setState({ companyData: companyData });
      });
  };

  // This method is used for searching
  submitSearchForm(searchText) {
    var me = this;
    // if (searchText != "" && searchText != null) {
    //   this.props.navigation(
    //     this.state.companyData,
    //     "SHOW_COMPANY_DETAIL",
    //     searchText.trim()
    //   );
    //   this.setState({ isLoading: false, searchTextValue: searchText.trim() });
    // } else {
    //   this.setState({ searchTextValue: "" });
    //   this.props.navigation(this.state.companyData, "SHOW_COMPANY_DETAIL", "");
    // }

    this.setState({ searchTextValue: searchText.trimStart() });
  }

  deleteButtonFormatter(cell, row) {
    return (
      <IconButton
        onClick={() => {
          this.deleteMailingTypeListUser(row);
        }}
        style={{
          width: "25px",
          height: "25px",
          padding: "0px",
          paddingLeft: "15px",
        }}
      >
        <img src={deleteDefaultIcon} />
      </IconButton>
    );
  }

  editButtonFormatter(cell, row) {
    return (
      <IconButton
        onClick={() => {
          this.editMailingTypeListUser(row);
        }}
        style={{
          width: "25px",
          height: "25px",
          padding: "0px",
          paddingLeft: "15px",
        }}
      >
        <img src={editDefaultIcon} />
      </IconButton>
    );
  }

  editMailingTypeListUser = (row) => {
    let employee = {};
    employee.empId = row.empId;
    employee.name = row.name;
    employee.email = row.email;
    this.setState({ employee: employee, isEmployeeEdit: true });
  };

  clearSearchText() {
    this.setState({ searchTextValue: "" });
  }

  renderEmployeeTable = () => {
    if (this.state.isLoading) {
      return (
        <div className="container">
          <center>
            <Loading color={"#424242"} />
          </center>
        </div>
      );
    } else {
      let { companyData } = this.state;

      return (
        <div
          className="mainTableCls"
          style={{ overflowY: "inherit", width: "95%", margin: "0 auto" }}
        >
          <div>
            <div>
              <div className="searchTextCls">
                <input
                  type="text"
                  value={this.state.searchTextValue}
                  className="searchInputCls"
                  placeholder="Search"
                  onChange={(e) => this.submitSearchForm(e.target.value)}
                />
                <span
                  className="searchImgCls"
                  onClick={(e) => {
                    this.clearSearchText();
                  }}
                >
                  <img src={closeIcon} style={{ width: "10px" }} />
                </span>
              </div>
            </div>
            <BootstrapTable
              data={companyData.employees.filter((employee) =>
                employee.name
                  .toLowerCase()
                  .includes(this.state.searchTextValue.toLowerCase()),
              )}
              bordered={false}
              pagination
            >
              <TableHeaderColumn
                dataField="employeeId"
                width="100"
                isKey={true}
                hidden={true}
              ></TableHeaderColumn>
              <TableHeaderColumn dataField="name" width="100">
                Name
              </TableHeaderColumn>
              <TableHeaderColumn dataField="email" width="100">
                Email
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="button"
                dataFormat={this.editButtonFormatter}
                width="20"
              ></TableHeaderColumn>
              <TableHeaderColumn
                dataField="button"
                dataFormat={this.deleteButtonFormatter}
                width="20"
              ></TableHeaderColumn>
            </BootstrapTable>
          </div>
        </div>
      );
    }
  };

  showCompanyList = () => {
    this.setState({
      searchTextValue: "",
      isEmployeeEdit: false,
      employee: { name: "", empId: "", email: "" },
    });
    this.props.getAllCompanyData();
    this.props.showPayrollPage();
  };

  handleToastClose = () => {
    this.setState({ showToast: false, toastMsg: "" });
  };

  renderContent() {
    let { response, isLoading } = this.state;
    let { zone, activeZone, centerStyle } = this.state.styles;
    let filter = { type: "TextFilter", delay: 500 };

    if (isLoading) {
      let size = window.screen.width / 7;
      return <CircularProgress color={"#424242"} size={size} thickness={20} />;
    }
    return (
      <div style={{ padding: "2rem" }}>
        <Dropzone
          onDrop={this.onDrop}
          disablePreview={true}
          style={zone}
          activeStyle={activeZone}
        >
          <center>
            <h4 className="uploadAttachmentTextAlign">
              {this.state.file ? this.state.file.name : this.state.message}
            </h4>
          </center>
        </Dropzone>
      </div>
    );
  }

  closeDeleteConfirmPopup = () => {
    this.setState({ openDeleteConfirmPopup: false });
  };

  resetForm = () => {
    this.setState({ file: "", response: "", isLoading: false });
  };

  showAddCompany = () => {
    if (this.state.companyData.companyId) {
      this.setState({ companyOpen: true, company: this.state.companyData });
    } else {
      this.setState({ companyOpen: true, company: {} });
    }
  };
  closeAddCompanyPopup = () => {
    this.setState({ companyOpen: false, company: {} });
  };

  resetEmployeeField = () => {
    this.setState({
      isEmployeeEdit: false,
      employee: { empId: "", name: "", email: "" },
    });
  };

  render() {
    let {
      companyData,
      employee,
      showToast,
      toastMsg,
      openDeleteConfirmPopup,
      isEmployeeEdit,
    } = this.state;
    let { open } = this.props;
    return (
      <div style={{ display: open ? "block" : "none" }}>
        <Snackbar
          style={{ bottom: "none", backgroundColor: "green" }}
          open={false}
          autoHideDuration={6000}
          message={toastMsg}
        />
        <div style={{ margin: "1em" }}>
          <span className="companyListTitle">Pay Stub Porter</span>
        </div>
        <div
          style={{
            minHeight: "calc(100vh - 40px)",
            marginLeft: "1em",
            marginRight: "1em",
          }}
        >
          <div className="row">
            <div
              className="column d-flex align-items-stretch"
              style={{ backgroundColor: "#fff" }}
            >
              <div style={{ width: "100%" }}>
                <div
                  className="addCompanyHeader"
                  style={{ display: "flex", margin: "0px" }}
                >
                  <div
                    style={{
                      marginTop: "-0.5rem",
                      marginLeft: "-2rem",
                      width: "100%",
                    }}
                  >
                    <div
                      style={{ display: "inline-block", width: "10%" }}
                      className="genericUploaderBackIconCls"
                    >
                      <IconButton
                        aria-label="close"
                        style={{ width: "25px" }}
                        onClick={this.showCompanyList}
                      >
                        <img
                          src={backIcon}
                          style={{
                            width: "16px",
                            marginRight: "5px",
                            marginTop: "-5px",
                          }}
                        />
                      </IconButton>
                    </div>
                    <div
                      style={{
                        display: "inline-block",
                        width: "80%",
                        textAlign: "center",
                      }}
                    >
                      <span>
                        {companyData.company != ""
                          ? companyData.company
                          : "Update Company"}
                      </span>
                    </div>
                  </div>
                </div>
                <div>
                  <div style={{ marginLeft: "1rem" }}>
                    <div>
                      <TextField
                        floatingLabelText="Employee Id"
                        value={employee.empId}
                        disabled={isEmployeeEdit}
                        style={{ width: "30rem" }}
                        onChange={(e) =>
                          this.onCompanyEmployeeValue("empId", e.target.value)
                        }
                      />
                      <TextField
                        floatingLabelText="Name"
                        value={employee.name}
                        style={{ width: "30rem" }}
                        onChange={(e) =>
                          this.onCompanyEmployeeValue("name", e.target.value)
                        }
                      />
                      <TextField
                        floatingLabelText="Email"
                        value={employee.email}
                        style={{ width: "30rem" }}
                        onChange={(e) =>
                          this.onCompanyEmployeeValue("email", e.target.value)
                        }
                      />
                    </div>
                    {isEmployeeEdit ? (
                      <div style={{ float: "right", marginRight: "2rem" }}>
                        <FlatButton
                          onClick={this.resetEmployeeField}
                          className="flatButtonCls"
                        >
                          Reset
                        </FlatButton>
                        <FlatButton
                          onClick={this.editEmployee}
                          className="flatButtonCls"
                          style={{ marginLeft: "5px" }}
                        >
                          <img src={addArrowIcon} /> Update
                        </FlatButton>
                      </div>
                    ) : (
                      <div style={{ float: "right", marginRight: "2rem" }}>
                        <FlatButton
                          onClick={this.addEmployee}
                          className="flatButtonCls"
                        >
                          <img src={addArrowIcon} /> Add
                        </FlatButton>
                      </div>
                    )}
                  </div>
                  <br />
                  <hr />
                  {this.renderEmployeeTable()}
                </div>
              </div>
            </div>
            <div className="column d-flex align-items-stretch rightMainDiv">
              <div>
                <Formsy.Form
                  ref="form"
                  onValidSubmit={this.submitNoteForm}
                  onInvalidSubmit={this.notifyFormError}
                >
                  <FormsyText
                    multiLine
                    name="note"
                    placeholder="Note..."
                    InputProps={{ disableUnderline: true }}
                    style={{
                      width: "93%",
                      marginLeft: "2rem",
                      marginBottom: "0",
                      height: "70px",
                      border: "1px solid #ccc",
                      padding: "10px",
                      marginTop: "0px",
                      maxHeight: "90px",
                    }}
                  />
                </Formsy.Form>
              </div>
              {this.renderContent()}
              <div
                style={{
                  display: "inline-block",
                  lineHeight: "36px",
                  marginTop: "1rem",
                  padding: "8px",
                }}
              >
                <Link href="/api/employee_template" target="_blank">
                  <img
                    src={downloadIcon}
                    style={{ width: "16px", marginRight: "5px" }}
                  />
                  Download Employee Template
                </Link>
              </div>
              <div
                style={{
                  float: "right",
                  marginTop: "1rem",
                  right: "30px",
                  bottom: "20px",
                  display: "inline-block",
                }}
              >
                <FlatButton
                  disabled={this.state.isLoading}
                  onClick={this.resetForm}
                  className="flatButtonCls"
                >
                  Reset
                </FlatButton>
                <FlatButton
                  disabled={this.state.companyData.companyId ? false : true}
                  onClick={this.submitForm}
                  style={{ marginLeft: "2rem" }}
                  className="flatButtonCls"
                >
                  Submit
                </FlatButton>
              </div>
            </div>
          </div>
        </div>
        <Dialog
          title="Delete User"
          open={openDeleteConfirmPopup}
          onRequestClose={this.closeDeleteConfirmPopup}
          style={{ width: "50%", textAlign: "center" }}
        >
          Are you sure you want to delete this user?
          <br />
          <br />
          <FlatButton
            type="button"
            className="flatButtonCls"
            onTouchTap={this.deleteConfirmPopupClick}
          >
            Yes
          </FlatButton>
          <FlatButton
            type="button"
            style={{ marginLeft: "2rem" }}
            className="flatButtonCls"
            onTouchTap={this.closeDeleteConfirmPopup}
          >
            No
          </FlatButton>
        </Dialog>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/Payroll/ShowCompanyDetail.js